export const exportToExcel = (data: Record<string, any>[], filename: string) => {
  if (data.length === 0) return;

  // Obtener las columnas del primer objeto
  const headers = Object.keys(data[0]);

  // Crear el contenido CSV
  const csvContent = [
    // Headers
    headers.join(','),
    // Rows
    ...data.map(row =>
      headers
        .map(header => {
          const value = row[header];
          // Escapar comillas y envolver en comillas si contiene comas o comillas
          if (value === null || value === undefined) return '';
          const stringValue = String(value).replace(/"/g, '""');
          return stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')
            ? `"${stringValue}"`
            : stringValue;
        })
        .join(',')
    ),
  ].join('\n');

  // Crear BOM para UTF-8 (Excel lo necesita para caracteres especiales)
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

  // Crear link y descargar
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

